import React from "react";
import { Formik } from "formik";
import { injectIntl, FormattedMessage } from "react-intl";

import { updateUserDetails } from "../../services/moocfi";
import StyledForm from "../StyledForm";
import { currentLocale } from "../../services/locale";
import {
  ResearchAndMarketingForm
} from "../ExtraInfo";
import CountrySelect from "../SignUp/CountrySelect";
import LanguageSelect from "../SignUp/LanguageSelect";
import { createMailchimpSubscriber } from "../../services/zapier";
import { Error, Success, SubmitButton } from "./AccountFormStyles";
import _ from "lodash";

import { syncStore } from "../../state/appStore";

const formStatus = {
  SUBMITTED: "SUBMITTED"
};

class UserDetailsForm extends React.Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.state = Object.assign({}, props);
  }

  render() {
    const onSubmit = (values, { setSubmitting, setErrors, setStatus }) => {
      setSubmitting(true);
      setStatus(null);
      const userField = {
        first_name: values.firstName,
        last_name: values.lastName,
        organizational_id: values.studentNumber
      };
      const extraFields = {
        deadline: "self-paced",
        helsinki_university: values.helsinki_university,
        open_university: values.open_university,
        research: values.research,
        marketing: values.marketing,
        language: values.language,
        country: values.country,
        postal_code: values.postal_code
      };
      const userInfo = {
        email: values.email
      };
      updateUserDetails({ userField, extraFields, userInfo }).then(
        res => {
          setSubmitting(false);
          setStatus(formStatus.SUBMITTED);
          syncStore({ locale: values.language });
          createMailchimpSubscriber(values);
          if (this.props.onComplete) {
            this.props.onComplete();
          }
        },
        res => {
          setSubmitting(false);
          console.log("Profile update failed", res);
          if (res.status === 403) {
            setErrors({
              form: this.props.intl.formatMessage({
                id: "userDetails.authError"
              })
            });
          } else if (res.status === 500) {
            setErrors({
              form: this.props.intl.formatMessage({
                id: "userDetails.unexpError"
              })
            });
          } else {
            const errors = _.get(res, "data.errors", {});
            setErrors(errors);
          }
        }
      );
    };

    const validate = (values, props) => {
      let errors = {};
      if (_.isEmpty(values.email)) {
        errors.email = this.props.intl.formatMessage({
          id: "userDetails.required"
        });
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(values.email)
      ) {
        errors.email = this.props.intl.formatMessage({
          id: "userDetails.invalidEmail"
        });
      }

      if (_.isEmpty(values.firstName)) {
        errors.firstName = this.props.intl.formatMessage({
          id: "userDetails.required"
        });
      }

      if (_.isEmpty(values.lastName)) {
        errors.lastName = this.props.intl.formatMessage({
          id: "userDetails.required"
        });
      }

      return errors;
    };

    return (
      <div>
        <Formik
          initialValues={this.state}
          onSubmit={onSubmit}
          validate={validate}
          render={({
            values,
            errors,
            isValid,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            status,
          }) => (
            <StyledForm>
              <form onSubmit={handleSubmit}>
                <fieldset>
                  <label htmlFor="email">
                    <FormattedMessage id="userDetails.email" />
                  </label>
                  <input
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="email"
                    id="email"
                    name="email"
                    placeholder={this.props.intl.formatMessage({
                      id: "userDetails.emailAddress"
                    })}
                  />
                  {touched.email && errors.email && (
                    <Error>{errors.email}</Error>
                  )}

                  <label htmlFor="firstName">
                    <FormattedMessage id="userDetails.firstName" />
                  </label>
                  <input
                    value={values.firstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="text"
                    id="firstName"
                    name="firstName"
                    placeholder={this.props.intl.formatMessage({
                      id: "userDetails.firstName"
                    })}
                  />
                  {touched.firstName && errors.firstName && (
                    <Error>{errors.firstName}</Error>
                  )}

                  <label htmlFor="lastName">
                    <FormattedMessage id="userDetails.lastName" />
                  </label>
                  <input
                    value={values.lastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="lastName"
                    name="lastName"
                    type="text"
                    placeholder={this.props.intl.formatMessage({
                      id: "userDetails.lastName"
                    })}
                  />
                  {touched.lastName && errors.lastName && (
                    <Error>{errors.lastName}</Error>
                  )}
                  {/*values.country !== "Sweden" &&
                    ["en", "fi", "se"].includes(currentLocale()) && (
                      <React.Fragment>
                        <label htmlFor="studentNumber">
                          <FormattedMessage id="signUp.studentNumber" />
                        </label>
                        <input
                          type="text"
                          name="studentNumber"
                          id="studentNumber"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.studentNumber}
                        />
                        {touched.studentNumber && errors.studentNumber && (
                          <Error>{errors.studentNumber}</Error>
                        )}
                      </React.Fragment>
                        )*/}
                  <label htmlFor="country">
                    <FormattedMessage id="signUp.country" />
                  </label>
                  <select
                    name="country"
                    id="country"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.country ? values.country : "Finland"}
                  >
                    <CountrySelect />
                  </select>
                  {values.country !== "Latvia" && currentLocale() !== "lv" && (
                    <React.Fragment>
                      <label htmlFor="postal_code">
                        <FormattedMessage id="signUp.postalCode" />
                      </label>
                      <input
                        type="text"
                        name="postal_code"
                        id="postal_code"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.postal_code}
                      />
                    </React.Fragment>
                  )}
                  <label htmlFor="language">
                    <FormattedMessage id="userDetails.language" />
                  </label>
                  <select
                    value={values.language}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="language"
                    name="language"
                  >
                    <LanguageSelect country={values.country} />
                  </select>

                  {touched.lastName && errors.lastName && (
                    <Error>{errors.language}</Error>
                  )}
                </fieldset>
                {/* This is being phased out. Leaving it as a comment for now in case for some reason removing this breaks something */}
                {/*values.country === "Sweden" ? (
                  <ECSTFormSweden showHeader={false} />
                ) : (
                  ["en", "fi", "se"].includes(currentLocale()) && (
                    <ECTSForm
                      values={values}
                      touched={touched}
                      errors={errors}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      handleSubmit={handleSubmit}
                    />
                  )
                  )*/}
                <ResearchAndMarketingForm
                  values={values}
                  touched={touched}
                  errors={errors}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  handleSubmit={handleSubmit}
                  intl={this.props.intl}
                  hidePolicy={this.props.hidePolicy}
                />
                <fieldset>
                  {errors.form && <Error>{errors.form}</Error>}
                </fieldset>
                <SubmitButton type="submit" disabled={isSubmitting || !isValid}>
                  {this.props.intl.formatMessage({
                    id: isSubmitting
                      ? "userDetails.updatingProfile"
                      : "userDetails.updateProfile"
                  })}
                </SubmitButton>
                {status === formStatus.SUBMITTED && (
                  <Success>
                    <FormattedMessage id="userDetails.profileUpdated" />
                  </Success>
                )}
              </form>
            </StyledForm>
          )}
        />
      </div>
    );
  }
}

export default injectIntl(UserDetailsForm);
